import { VNode, h } from "preact";
import { UIFormProps } from "../FormProvider.js";
import { InputLine } from "./InputLine.js";

export function InputText(
  props: UIFormProps<string>,
): VNode {
  return <InputLine type="text" {...props} />;
}
